<template>
  <div v-if="dialog" class="phone-frame-wrapper" @click.self="close">
    <v-card
      class="phone-frame-container"
      :style="frameStyle"
      style="position: absolute !important"
    >
      <div class="phone-frame-content">
        <v-btn icon class="close-btn" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="phone-content" style="width: 100%; height: 100%;">
          <slot></slot>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "phoneFrame",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    closeButtonText: {
      type: String,
      default: "بستن",
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    frameStyle() {
      return this.backgroundImage
        ? {
            backgroundImage: `url(${this.backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
          }
        : {
            backgroundColor: "#f0f0f0" // Default background if no image
          };
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.phone-frame-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  padding: 0px !important;
  margin: 0px !important;
  height: 100% !important;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
}

.phone-frame-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.close-btn {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5) !important;
  color: white !important;
}

.phone-content {
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.phone-frame-wrapper {
  position: absolute;
  inset: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  padding: 0px;
  margin: 0px;
}
</style>
